import type { FieldError } from './errors'
import './formError.css'

/**
 * Renders a form-level failure. Field-level ones go to the `Field` itself.
 *
 * Takes the whole `FieldError` and decides, rather than taking a string the
 * caller has already filtered: every screen would otherwise write the same
 * `error.field === 'form' ? error.message : undefined` and one of them would
 * eventually write it wrong, putting an account-level message under the email
 * box. M1-R2 is about which control carries which message.
 *
 * **It lives here rather than in `routes/auth/AuthCard`**, which is where it
 * started. Settings and first run both render auth failures, and importing it
 * from there reached into another route module's internals — dragging
 * AuthCard's stylesheet along, so restyling the sign-in card would silently
 * restyle Settings. It belongs beside `FieldError` and `authErrorFor`, which
 * were already here.
 */
export function FormError({ error }: { error: FieldError | null }) {
  if (error === null || error.field !== 'form') return null
  return (
    <p className="form-error" role="alert">
      {error.message}
    </p>
  )
}
